module.exports = __webpack_public_path__ + "img/content1.d2a80714.png";